import FJImageToImageLeftContainer from './FJImageToImageLeft/FJImageToImageLeftContainer.jsx';
import FJImageToImageRightContainer from './FJImageToImageRight/FJImageToImageRightContainer.jsx';
//本地字体调试
import FJAnimateImageModalContainer from '../FJModals/FJAnimateImageModal/FJAnimateImageModalContainer';

function FJImageToImage() {
    return (
        <>
            <FJImageToImageLeftContainer />
            <FJImageToImageRightContainer />
            <FJAnimateImageModalContainer />
        </>
    );
}

export default FJImageToImage;
